import PromoTileWrapper from "../PromoTileWrapper";
import PropTypes from "prop-types";
import {
  FLOOR_MEN,
  FLOOR_WOMEN
} from "../../../../../state/modules/config/constants";
import styles from "./PromoTile.css";

const config = {
  COM: {
    FLOOR_TO_TRANSLATIONS_MAPPING: {
      [FLOOR_MEN]: {
        heading: "TOPMAN",
        copy: "Shop the latest collection from Topman, exclusively @ ASOS now.",
        discover_more: "DISCOVER MORE"
      },
      [FLOOR_WOMEN]: {
        heading: "TOPSHOP",
        copy:
          "Shop the latest collection from Topshop, exclusively @ ASOS now.",
        discover_more: "DISCOVER MORE"
      }
    },
    FLOOR_TO_URL_MAPPING: {
      [FLOOR_MEN]: "https://www.asos.com/topman/?ctaref=plp-tile",
      [FLOOR_WOMEN]: "https://www.asos.com/topshop/?ctaref=plp-tile"
    }
  },
  US: {
    FLOOR_TO_TRANSLATIONS_MAPPING: {
      [FLOOR_MEN]: {
        heading: "TOPMAN",
        copy: "Shop the latest collection from Topman, exclusively @ ASOS now.",
        discover_more: "DISCOVER MORE"
      },
      [FLOOR_WOMEN]: {
        heading: "TOPSHOP",
        copy:
          "Shop the latest collection from Topshop, exclusively @ ASOS now.",
        discover_more: "DISCOVER MORE"
      }
    },
    FLOOR_TO_URL_MAPPING: {
      [FLOOR_MEN]:
        "https://www.asos.com/us/men/a-to-z-of-brands/topman/cat/?cid=29065#ctaref-plp-tile",
      [FLOOR_WOMEN]:
        "https://www.asos.com/us/women/a-to-z-of-brands/topshop/topshop-new-arrivals/cat/?cid=50698#ctaref-plp-tile"
    }
  },
  FR: {
    FLOOR_TO_TRANSLATIONS_MAPPING: {
      [FLOOR_MEN]: {
        heading: "TOPMAN",
        copy:
          "Shoppe la dernière collection de Topman, exclusivement sur ASOS maintenant.",
        discover_more: "DÉCOUVRIR"
      },
      [FLOOR_WOMEN]: {
        heading: "TOPSHOP",
        copy:
          "Shoppe la dernière collection de Topshop, exclusivement sur ASOS maintenant.",
        discover_more: "DÉCOUVRIR"
      }
    },
    FLOOR_TO_URL_MAPPING: {
      [FLOOR_MEN]:
        "https://www.asos.com/fr/homme/a-to-z-of-brands/topman/cat/?cid=29065#ctaref-plp-tile",
      [FLOOR_WOMEN]:
        "https://www.asos.com/fr/femme/a-to-z-of-brands/topshop/nouveautes-topshop/cat/?cid=50698#ctaref-plp-tile"
    }
  },
  DE: {
    FLOOR_TO_TRANSLATIONS_MAPPING: {
      [FLOOR_MEN]: {
        heading: "TOPMAN",
        copy:
          "Shoppe jetzt die neueste Kollektion von Topman, exklusiv @ ASOS.",
        discover_more: "MEHR ENTDECKEN"
      },
      [FLOOR_WOMEN]: {
        heading: "TOPSHOP",
        copy:
          "Shoppe jetzt die neueste Kollektion von Topshop, exklusiv @ ASOS.",
        discover_more: "MEHR ENTDECKEN"
      }
    },
    FLOOR_TO_URL_MAPPING: {
      [FLOOR_MEN]:
        "https://www.asos.com/de/herren/a-to-z-of-brands/topman/cat/?cid=29065#ctaref-plp-tile",
      [FLOOR_WOMEN]:
        "https://www.asos.com/de/damen/a-to-z-of-brands/topshop/neues-von-topshop/cat/?cid=50698#ctaref-plp-tile"
    }
  }
};

const PromoTile = ({ storeCode, floor }) => {
  const { FLOOR_TO_TRANSLATIONS_MAPPING, FLOOR_TO_URL_MAPPING } = config[
    storeCode
  ];
  const linkUrl = FLOOR_TO_URL_MAPPING[floor];
  const { heading, copy, discover_more } = FLOOR_TO_TRANSLATIONS_MAPPING[floor];

  return (
    <PromoTileWrapper linkUrl={linkUrl}>
      <div className={styles.promoTile}>
        <div className={styles.heading}>{heading}</div>
        <div className={styles.copy}>{copy}</div>
        <div className={styles.discover_more_wrapper}>
          <div className={styles.discover_more}>{discover_more}</div>
        </div>
      </div>
    </PromoTileWrapper>
  );
};

PromoTile.propTypes = {
  storeCode: PropTypes.string.isRequired,
  floor: PropTypes.string.isRequired
};

export default PromoTile;
